const Navigation = () => {
    var returnObj = {};
    /**
     * Initial functions / methods
     */
    returnObj.initial = function () {
        // set the link with dropdown the link-event back
        jQuery('.mainnav a[data-bs-toggle="dropdown"]').on('click', function () {
            window.location.href = jQuery(this).attr('href');
        });

        jQuery('.mainnav .nav-flyout').each(function (i, e) {
            // adding class to fix styling for flyout-navs with glyphicons
            if (jQuery(e).find('.glyphicons:not(".visible-xs-block")').length >= 1) {
                jQuery(e).addClass('nav-has-glyphicon');
            }
        });

        //  remove if clicked on xs-mainnav-backdrop
        jQuery(document).on('click', '.xs-mainnav-backdrop', function () {
            jQuery('[data-bs-target=".xs-mainnav"]').click();
        });
    };

    /**
     * XS-Size main navigation functionality
     */
    /** initial variables (is set in events-responsive.js too) */
    returnObj.jsScreenSMmin = parseFloat(jQuery('.js-screen-sm-min-max').css('min-width'));
    returnObj.hashXSSActive = '.xs-special-active';

    /**
     * initialize the xsNavigation
     */
    returnObj.xsNavigation = function () {
        returnObj.deactivatePagerNavi();

        jQuery('.xs-mainnav .resetNav').on('click', function (event) {
            returnObj.resetNav(event, true)
        });
        jQuery('.xs-mainnav .goLvlUp').on('click', function (event) {
            returnObj.goLvlUp(event);
        });

        jQuery('.xs-mainnav [data-bs-toggle="dropdown"]').removeAttr('data-bs-toggle'); // remove click Event: bootstrap-dropdown

        returnObj.setAllLevels(jQuery('.xs-mainnav > .nav:not(.nav-xs-special) li.dropdown:not(.xs-special-active)'));
    };


    /**
     * Set all navigation points an event to go lvl depper
     * activate pager navigation
     *
     * @param jQueryHash
     */
    returnObj.setAllLevels = function (jQueryHash) {
        jQueryHash.each(function (i, e) {
            jQuery(e).children('a').on('click', function (event) {
                // Avoid following the href location if clicked
                event.preventDefault();

                // Avoid having the menu to close if clicked
                event.stopPropagation();
                if (jQuery(event.currentTarget).parent().hasClass('xs-special-active show') || jQuery(event.currentTarget).is(":last-child")) {
                    window.location = jQuery(event.currentTarget).attr('href');
                } else {
                    returnObj.goLvlDown(event.currentTarget);
                    returnObj.activatePagerNavi();
                }
            });
        })
    };


    /**
     * Active the pager from navigation
     * back and overview buttons
     */
    returnObj.activatePagerNavi = function () {
        jQuery('.nav-xs-special:not(.nav-xs-lang) a.btn').removeClass('disabled');
    };

    /**
     * Deactivate the pager from navigation
     * back and overview buttons
     */
    returnObj.deactivatePagerNavi = function () {
        jQuery('.nav-xs-special:not(.nav-xs-lang) a.btn').addClass('disabled');
    };

    /**
     * This is a function to go one lvl deeper on navigation point
     * if this point have a subnavigation
     *
     * @param e
     */
    returnObj.goLvlDown = function (e) {
        jQuery(returnObj.hashXSSActive + ' > a').addClass('hidden');
        jQuery(e).parent().addClass('xs-special-active show').parent().children('li:not(' + returnObj.hashXSSActive + ')').addClass('hidden');
        $('.xs-special-active').find('> ul').addClass('nav');
        returnObj.setAllLevels(jQuery(e).find('> .dropdown-menu > ul > li'));
    };

    /**
     * This is a function to go navigation point one lvl up
     * This function (event) is triggered for the back-button
     *
     * @param event object
     */
    returnObj.goLvlUp = function (event) {
        // Avoid following the href location if clicked
        event.preventDefault();

        // Avoid having the menu to close if clicked
        event.stopPropagation();
        if (jQuery(returnObj.hashXSSActive).length > 1) {

            jQuery(returnObj.hashXSSActive).last().removeClass('xs-special-active show').children('ul').children('li').addClass('hidden');
            jQuery(returnObj.hashXSSActive).children('ul').children('li').removeClass('hidden')

        } else {
            jQuery(returnObj.hashXSSActive).parent().find('.hidden').removeClass('hidden');
            jQuery(returnObj.hashXSSActive).find('>ul').removeClass('nav');
            jQuery(returnObj.hashXSSActive).removeClass('xs-special-active show');
        }

        if (jQuery(returnObj.hashXSSActive).length <= 0) {
            returnObj.deactivatePagerNavi();
        }
    };

    /**
     * This function make a navigation reset, to reset back to start
     * This event ist triggered fpr the overview-button
     *
     * @param event object
     * @param onXsNav boolean
     */
    returnObj.resetNav = function (event, onXsNav) {
        if (onXsNav) {
            // Avoid following the href location if clicked
            event.preventDefault();

            // Avoid having the menu to close if clicked
            event.stopPropagation();
        }
        if (event === false && onXsNav === false) {
            jQuery('.xs-mainnav .xs-special-active a').unbind('click');
        }
        jQuery('.xs-mainnav ' + returnObj.hashXSSActive).removeClass('xs-special-active show');
        jQuery('.xs-mainnav .hidden').removeClass('hidden');
        returnObj.deactivatePagerNavi();
    };


    /**
     * nav-wizard
     * this function looks for the highest step and set all other to the same height
     * this fix the nav-justified bug and if a step multilined
     */
    returnObj.fixNavWizard = function () {
        jQuery('.nav-wizard').each(function (i, wizard) {
            var heighestStep = 0;
            var borderWidth = -1;


            jQuery(wizard).children().children('a').each(function (ii, step) {
                var stepHeight = jQuery(step).outerHeight();
                if (stepHeight > heighestStep) {
                    heighestStep = stepHeight;
                }
            });

            jQuery(wizard).children().children('a').each(function (ii, step) {
                var stepHeight = jQuery(step).outerHeight();
                var diff = (heighestStep - stepHeight);
                var diffH = Math.ceil(diff / 2);
                var paddingT = parseFloat(jQuery(step).css('padding-top'));
                var paddingB = parseFloat(jQuery(step).css('padding-bottom'));
                if (stepHeight != heighestStep) {
                    jQuery(step).css({
                        'padding-top': (paddingT + diffH) + 'px',
                        'padding-bottom': (paddingB + diffH) + 'px'
                    })
                }

                if (borderWidth <= 0) {
                    borderWidth = parseFloat(jQuery(step).next().css('border-top-width'));
                    borderWidth = (borderWidth + diffH);
                }

                if (borderWidth >= 0) {
                    var borderBWidth = borderWidth;
                    if (diffH != 0) {
                        borderBWidth = (borderWidth + 1);
                    }

                    jQuery(step).next().css({
                        'border-top-width': borderWidth + 'px',
                        'border-bottom-width': borderBWidth + 'px'
                    });

                    jQuery(step).prev().css({
                        'border-top-width': borderWidth + 'px',
                        'border-bottom-width': borderBWidth + 'px'
                    });
                }
            });
        });
    };


    /** breacrumb navigation special for product detail pages for only xs-size */
    returnObj.xsBreadcrumb = function () {
        var lis = jQuery('.breadcrumb').not('.d-none d-sm-block').children().not('.d-none d-sm-block').clone();
        if (lis.length >= 1) {
            jQuery('.breadcrumb').addClass('d-none d-sm-block').after('<nav class="row-breadcrumb"><ul class="nav nav-breadcrumb d-none js-special-breadcrumb"></ul></nav>');
            jQuery('.js-special-breadcrumb').append(lis);
            jQuery('.js-special-breadcrumb a').append('<span class="glyphicons glyphicons-chevron-right float-end"></span>');
        }
    };

    /**
     * initial loadings
     */
    returnObj.initial();
    returnObj.fixNavWizard();

    return returnObj;
}
export const navigation = Navigation();
